import BTC from '../../../assets/icons/BTC.svg'
import USDT from '../../../assets/icons/USDT.svg'
import BLC from '../../../assets/icons/BLC.svg'
import AED from '../../../assets/icons/AED.svg'
import IRT from '../../../assets/icons/IRT.svg'
import USD from '../../../assets/icons/USD.svg'
import CAD from '../../../assets/icons/CAD.svg'
import GBP from '../../../assets/icons/GBP.svg'
import EUR from '../../../assets/icons/EUR.svg'
import TRY from '../../../assets/icons/TRY.svg'
import OMR from '../../../assets/icons/OMR.svg'
import IQD from '../../../assets/icons/IQD.svg'
import AMD from '../../../assets/icons/AMD.svg'
import AUD from '../../../assets/icons/AUD.svg'
import RUB from '../../../assets/icons/RUB.svg'
import CNY from '../../../assets/icons/CNY.svg'
import app from '../../../main.js'
import axios from 'axios';


export class Asset {
    iconMap = {
        'USDT': USDT,
        'BLC': BLC,
        'AED': AED,
        'IRT': IRT,
        'USD': USD,
        'CAD': CAD,
        'TRY': TRY,
        'GBP': GBP,
        'EUR': EUR,
        'BTC': BTC,
        'OMR': OMR,
        'IQD': IQD,
        'AMD': AMD,
        'AUD': AUD,
        'CNY': CNY,
        'RUB': RUB,
    }

    static getBySymbol(symbol) {
        return new Promise((resolve, reject) => {
            axios
                .get('portfolio/asset/' + symbol)
                .then((response) => {
                    resolve(Asset.create(response.data))
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    static listByAdmin(page, pageSize, options) {
        return Asset.list(page, pageSize, options, 'portfolio/admin/assets')
    }

    static list(page, pageSize, options, url = 'portfolio/assets') {
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: { page: page, pageSize: pageSize, ...options }
                })
                .then((response) => {
                    resolve(response.data.data.map(_asset => Asset.create(_asset)))
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    static create(data, pathFromRoot = null, setupType) {
        if (pathFromRoot == null)
            pathFromRoot = []
        if (data == null)
            return null
        if (data instanceof Asset)
            return data
        for (let obj of pathFromRoot)
            if (obj instanceof Asset && obj.id == data.id)
                return obj
        return new Asset(data, pathFromRoot, setupType)
    }

    constructor(data, pathFromRoot, setupType = 'default') {
        if (setupType === 'bot') {
            this.setUpFromBot(data, pathFromRoot);
        } else {
            this.setUp(data, pathFromRoot);
        }
        this.loading = 0;
    }

    setUpFromBot(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.id = data.id
        this.symbol = data.symbol
        this.name = data.name
        this.icon = this.iconMap[data.symbol]
        this.quantityDecimals = this.symbol == "IRT" ? 5 : 1
        this.priceDecimals = 5
        this.dirhamPrice = 1
        pathFromRoot.pop()
    }

    setUp(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.id = data.id
        this.symbol = data.symbol
        this.name = data.name
        this.icon = this.iconMap[data.symbol]
        this.quantityDecimals = data.quantityDecimals
        this.priceDecimals = data.priceDecimals
        this.dirhamPrice = data.dirhamPrice
        this.type = ["USDT", "BLC"].includes(this.symbol) ? 'Coin' : 'Fiat'
        pathFromRoot.pop()
    }

    compare(quantityA, quantityB) {
        const a = app.config.globalProperties.$filters.formatDecimal(quantityA, this.quantityDecimals)
        const b = app.config.globalProperties.$filters.formatDecimal(quantityB, this.quantityDecimals)

        return a == b ? 0 : a > b ? 1 : -1
    }

    compareWithOtherAsset(otherAsset) {
        if (!(otherAsset instanceof Asset)) {
            throw new Error('The argument must be an instance of Asset.');
        }

        return this.symbol === otherAsset.symbol 
    }
}